import type { ApiResponse } from "@/scripts/Common/api";
import { defaultFetch } from "@/scripts/Common/api";
import { httpMethod } from "@/scripts/Common/api/enums";
import type { AddOrUpdateDeviceModel, Device, DeviceWithCustomer, FetchDevicesParam } from "./types";
import { getToken } from "@/scripts/Common";
import type { ImportResult } from "@/scripts/Common";
import i18n from "@/i18n";

const fetchDevices = async (args?: FetchDevicesParam, abortSignal?: AbortSignal): Promise<ApiResponse<DeviceWithCustomer[]>> => {
  return await defaultFetch({
    apiName: 'devices',
    bearer: getToken(),
    options: {
      query: {
        ...args,
        pageNumber: typeof args?.pageNumber === 'number' ? Math.max(0, args?.pageNumber - 1) : undefined,
      },
      abortSignal
    }
  });
}

const getDeviceById = async (deviceId: number): Promise<ApiResponse<Device>> => {
  return await defaultFetch({
    apiName: 'device',
    bearer: getToken(),
    options: {
      routeParams: {
        deviceId: deviceId.toString()
      }
    }
  });
}

const createDevice = async (model: AddOrUpdateDeviceModel): Promise<ApiResponse<void>> => {
  return await defaultFetch({
    apiName: 'devices',
    bearer: getToken(),
    body: JSON.stringify(model),
    options: {
      method: httpMethod.POST
    }
  });
}

const updateDevice = async (deviceId: number, model: AddOrUpdateDeviceModel): Promise<ApiResponse<void>> => {
  return await defaultFetch({
    apiName: 'device',
    bearer: getToken(),
    body: JSON.stringify(model),
    options: {
      method: httpMethod.PUT,
      routeParams: {
        deviceId: deviceId.toString()
      }
    }
  });
}

const deleteDevice = async (deviceId: number): Promise<ApiResponse<void>> => {
  return await defaultFetch({
    apiName: 'device',
    bearer: getToken(),
    options: {
      method: httpMethod.DELETE,
      routeParams: {
        deviceId: deviceId.toString()
      }
    }
  });
}

const importDevices = async (file: File): Promise<ApiResponse<ImportResult>> => {
  return await defaultFetch({
    apiName: 'devicesImport',
    bearer: getToken(),
    options: {
      method: httpMethod.PUT,
      headers: {
        'Content-Type': 'text/csv',
        'Authorization': `Bearer ${getToken()}`,
        'Accept-Language': i18n.global.locale.value
      }
    },
    body: file,
  });
}

export {
  fetchDevices,
  getDeviceById,
  createDevice,
  updateDevice,
  deleteDevice,
  importDevices
}
